var map = {
	"./cake.webp": 1974,
	"./crown-blue.webp": 1975,
	"./crown.webp": 1976,
	"./pocket.webp": 1977,
	"./present.webp": 1978,
	"./relegation.webp": 1979,
	"./t-deposit.webp": 1980,
	"./t-turnover.webp": 1981,
	"./vip-bg.webp": 1982,
	"./vip1.gif": 1983,
	"./vip1.webp": 1984,
	"./vip10-bg.webp": 1985,
	"./vip10.gif": 1986,
	"./vip10.webp": 1987,
	"./vip11-bg.webp": 1988,
	"./vip11.gif": 1989,
	"./vip11.webp": 1990,
	"./vip12-bg.webp": 1991,
	"./vip12.gif": 1992,
	"./vip12.webp": 1993,
	"./vip2.gif": 1994,
	"./vip2.webp": 1995,
	"./vip3.gif": 1996,
	"./vip3.webp": 1997,
	"./vip4.gif": 1998,
	"./vip4.webp": 1999,
	"./vip5.gif": 2000,
	"./vip5.webp": 2001,
	"./vip6.gif": 2002,
	"./vip6.webp": 2003,
	"./vip7.gif": 2004,
	"./vip7.webp": 2005,
	"./vip8.gif": 2006,
	"./vip8.webp": 2007,
	"./vip9.gif": 2008,
	"./vip9.webp": 2009
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 454;